import {http} from './index';
import {ClassListType, ClassStudentListType} from '@types';

// [class-list]-班级列表-查询
export const ClassListApi = (params: ClassListType) => http.get('/teaching-workbench/class/allClass', params);
// [class-list]-班级学员列表-查询
export const ClassStudentListApi = (params: ClassStudentListType) => http.get('/teaching-workbench/class/list/student', params);